// extracted by mini-css-extract-plugin
export default {"container":"RegisterSuccess_container__8LmP6","text":"RegisterSuccess_text__y5QLL"};